import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Vendor
export const addVendor = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/franchise/app/v1/create-vendor`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log({ error })
    throw error
  }
}

// update Injury
export const updateVendor = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/franchise/app/v1/update-vendor/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// delete Vendor 
export const deleteVendor = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/franchise/app/v1/delete-vendor/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// total count
export const countVendor = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/franchise/app/v1/count-vendor`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Get Vendor by ID
export const getVendorListById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/franchise/app/v1/get-vendor/${id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
